<template style="touch-action: none;">
  <v-container class="pa-0" fluid style="height:100%;background-image: linear-gradient(to top, #6a85b6 0%, #bac8e0 100%);">
    <v-row class="text-center">
      <v-alert
        v-show="alertShow"
        style="position: absolute;left: 2rem;bottom: 2rem; z-index: 99;"
        class="text-title text-md-h6"
        dense
        v-bind:type="alertType"
      >
        {{ alert }}
      </v-alert>
      <div class="position-center col-sm-12 col-lg-6">
      <v-expansion-panels v-model="panel" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <template v-slot:default="{ open }">
              <v-row no-gutters>
                <v-col class="col-sm-12 col-lg-4">
                  設定WIFI打卡點
                </v-col>
                <v-col
                  class="text--secondary d-none d-sm-none d-md-flex col-lg-8"
                  
                >
                  <v-fade-transition leave-absolute>
                    <span
                      v-if="open"
                      key="0"
                    >
                      請確保網路和WIFI分享器相通
                    </span>
                    <span
                      v-else
                      key="1"
                    >
                      {{ trip.ip }}
                    </span>
                  </v-fade-transition>
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row no-gutters>
            <v-col
              cols="8"
              class="text--secondary"
            >
            <v-text-field
              v-model="trip.ip"
              placeholder="手動輸入IP位置"
            ></v-text-field>
            </v-col>
            <v-col
              cols="4"
              class="text--secondary"
            >
            <v-btn
                color="#3cba92"
                dark
                depressed
                style="width: 100%; height: 70%;"
                @click="getWifi"
                class="text-caption text-md-subtitle-1"
                v-html="trip.message"
              >
              </v-btn>
            </v-col>
            <v-col
              v-show="tripShow"
              cols="12"
              class="text--secondary"
            >
            <v-text-field
              v-model="trip.name"
              :rules="[chk_Name]"
              placeholder="請輸入打卡設備名稱"
            ></v-text-field>
            </v-col>
            <v-col
              v-show="tripShow"
              cols="12"
              class="text--secondary"
            >
            <v-btn
                color="primary"
                v-bind:disabled="tripDisabled"
                depressed
                style="width: 100%;"
                @click="api_addPosition"
              >
                <v-icon>mdi-plus-circle</v-icon>
                新增打卡點
              </v-btn>
            </v-col>
          </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
    
        <v-expansion-panel class="d-none d-md-block">
          <v-expansion-panel-header v-slot="{ open }">
            <v-row no-gutters>
              <v-col cols="4">
                使用手機設置WIFI打卡點
              </v-col>
              <v-col
                cols="8"
                class="text--secondary"
              >
                <v-fade-transition leave-absolute>
                  <span
                    v-if="open"
                    key="0"
                  >
                    確保手機連上正確的WIFI設備
                  </span>
                  <span
                    v-else
                    key="1"
                  >
                    {{ trip.location }}
                  </span>
                </v-fade-transition>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row no-gutters>
              <v-col cols="5">
                <vue-qr :correctLevel="3" :autoColor="false" colorDark="#313a90" :text="codeUrl" :size="185" :margin="0" :logoMargin="3"></vue-qr>
              </v-col>    
              <v-col cols="3" class="text-left">
                1.打開手機<br/>2.連上WIFI設備<br/>3.掃描左側條碼進入設定頁面
                <br>
                <a href="https://official-blog-tw.line.me/archives/81358365.html" target="_blank">無法掃描QRCode嗎?</a>
              </v-col>
            </v-row>
    
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      </div>

      <v-dialog
        v-model="dialog"
        max-width="290"
      >
        <v-card>
          <v-card-title class="headline">
            提醒
          </v-card-title>
  
          <v-card-text>
            確定要刪除此打卡位置嗎?
            (刪除後將無法復原)
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
  
            <v-btn
              color="green darken-1"
              text
              @click="dialog=false"
            >
              取消
            </v-btn>
  
            <v-btn
              color="green darken-1"
              text
              @click="api_delWifi"
            >
              確定
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- <v-btn
          class="position-center"
          style="left: auto;top:auto;z-index: 99;"
          color="white"
          elevation="2"
          fab
        >
          <v-icon>mdi-menu</v-icon>
      </v-btn> -->
      <v-navigation-drawer
        absolute
        permanent
        right
        :opened="true" 
      >
        
        <template v-slot:prepend>
          <v-list-item two-line>
            <v-list-item-avatar>
              <img src="https://randomuser.me/api/Portraits/women/81.jpg">
            </v-list-item-avatar>
  
            <v-list-item-content>
              <v-list-item-title>群組名稱</v-list-item-title>
              <v-list-item-subtitle>{{ groupName }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-divider></v-divider>
        <v-list>
          <v-subheader>群組打卡位置</v-subheader>
          <v-list-item-group
            color="primary"
          >
            <v-list-item
              v-for="(mk, index) in item_ips"
              :key="'F'+ index"
            >
              <v-list-item-icon>
                <v-icon v-text="mk.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="mk.text"></v-list-item-title>
                <v-list-item-subtitle class="text-caption" v-text="mk.ip"></v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-content>
                
                <v-btn
                color="white"
                depressed
                @click="chk_del(mk)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
              </v-list-item-content>
              
            </v-list-item>
          </v-list-item-group>
        </v-list>
        <v-divider></v-divider>
      </v-navigation-drawer>
    </v-row>
  </v-container>
</template>

<script>
  Array.prototype.remove = function() {
      var what, a = arguments, L = a.length, ax;
      while (L && this.length) {
          what = a[--L];
          while ((ax = this.indexOf(what)) !== -1) {
              this.splice(ax, 1);
          }
      }
      return this;
  };
  import axios from 'axios';
  import VueQr from 'vue-qr'
  export default {
    name: 'App',
    props: ['baseURL','baseLINE','baseAPI','baseADMIN','tax'],
    components: {
      VueQr
    },
    data(){
      return{
        panel:[0],
        item_ips: [
          { text: 'Real-Time', icon: 'mdi-flag'},
          { text: 'Audience', icon: 'mdi-flag'},
          { text: 'Conversions', icon: 'mdi-flag'},
        ],
        alertShow:true,
        alertType:"info",
        alert:"請確保該設備與WIFI設備保持連線",
        attr_icon:"mdi-dots-horizonta",
        str_groupid:"",
        groupName:"",
        errorMessage:"",
        pre_del:null,
        dialog:false,
        date: null,
        trip: {
          ip: '',
          message:"開始設定WIFI設備",
          name:'',
          location: null,
          start: null,
          end: null,
        },
        tripShow:false,
        tripDisabled:true,
        locations: ['Australia', 'Barbados', 'Chile', 'Denmark', 'Ecuador', 'France'],
        codeUrl: window.location.href
      }
    },
    
    
    mounted() {
      this.$store.commit('SET_LAYOUT', "app-layout")
      let query = this.$route.query;
      this.str_groupid = query['Groupid'];
      this.api_getGroupInfo();
      //this.getWifi();
    },
    methods:{
      chk_Name(value){
        console.log("被檢測",value);
        if(value ==""){
          this.tripDisabled = true;
          return "請輸入打卡點名稱"
        }
        this.tripDisabled = false;
        this.alert = "記得按下新增打卡點保存位置哦!"
        this.alertType="info";
        return true;
      },
      api_getGroupInfo(){
        console.log("群組編號",this.str_groupid);
        if(this.str_groupid == null)return;
        axios
        .get(this.baseURL+'/api/Punch/GetAllIPAddress?str_GroupId='+this.str_groupid)
        .then((response)=>{
          console.log(response);
          let data = JSON.parse(response.data);
          this.groupName = data[0]["群組名稱"]
          this.item_ips = [];
          for(let group in data){
            let name = data[group]["fIPAddress_name"];
            if(name!=null){
              let ip = data[group]["fIPAddress"];
              let _new = { text: name,ip:ip, icon: 'mdi-wifi'};
              this.item_ips.push(_new);
            }
          }
        })
        .catch(function (error) { // 请求失败处理
          console.log(error);
          this.alert = "獲得資料失敗，請聯絡技術開發人員"
          this.alertType = "error";
        });
      },
      api_addPosition(){
        console.log("群組編號",this.str_groupid);
        if(this.str_groupid == null)return;
        axios
        .get(this.baseURL+'/api/Punch/GroupIPSet?str_GroupId='+ this.str_groupid +'&str_IPAddress='+ this.trip.ip +'&str_IPAddress_name='+this.trip.name)
        .then((response)=>{
          if(response.data == true){
            let _new = { text: this.trip.name,ip:this.trip.ip, icon: 'mdi-wifi'};
            this.item_ips.push(_new);
            this.trip.ip = "";
            this.trip.name = "";
            this.tripShow = false;
            this.tripDisabled = false;
            this.alert = "儲存成功，開始新增下一個標點吧!"
            this.alertType = "success";
          }else{
            this.alert = "儲存資料失敗，請聯絡技術開發人員"
            this.alertType = "error";
          }
          
          // let data = JSON.parse(response.data);
          // this.groupName = data[0]["群組名稱"]
          // this.item_ips = [];
        })
        .catch(function (error) { // 请求失败处理
          console.log(error);
          this.alert = "獲得資料失敗，請聯絡技術開發人員"
          this.alertType = "error";
        });
      },
      api_delWifi(){
        let item = this.pre_del;
        this.dialog = false;
        axios
        .get(this.baseURL+'/api/Punch/Dele_IP_Punch_in?str_GroupId='+ this.str_groupid +'&str_IPAddress_name='+item.text)
        .then((response)=>{
          if(response.data == true){
            this.alert = "刪除成功，可以開始新增新的標點"
            this.alertType = "success";
            this.item_ips.remove(item);
          }
        })
        .catch(function (error) { // 请求失败处理
          console.log(error);
          this.alert = "刪除失敗，請聯絡技術開發人員"
          this.alertType = "error";
        });
      },
      getWifi(){
        this.trip.message = "獲取此WIFI設備資訊中.."
        axios
        .get('https://api.ipify.org?format=json')
        .then((response)=>{
          this.trip.message = "重新設定設備資訊"
          let ip =  response.data.ip;
          this.trip.ip = ip;
          this.tripShow = true;
        })
        .catch(function (error) { // 请求失败处理
          console.log("錯誤資訊",error);
          this.alertType = "error";
          this.alert = "獲取ip失敗，請檢查是否有連上網路";
        });
      },
      chk_del(item){
        this.dialog = true;
        this.pre_del = item;
      },
    },
  }
  </script>
  <style>
    .text-small{
      font-size: 8px;
    }
    .position-center{
      position: relative;
      margin: auto;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
    }
  </style>